export default __webpack_public_path__ + "static/media/paint.bb71a7c7.jpg";